import React, { useEffect, useMemo, useState } from "react";
import { Box, Button, Checkbox, Container, FormControl } from "@mui/material";
import { InputLabel, MenuItem, Select, Stack, TextField } from "@mui/material";
import { Typography, FormControlLabel, RadioGroup, Radio } from "@mui/material";
import { FormLabel } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { styled } from "@mui/material/styles";
import ClipLoader from "react-spinners/ClipLoader";
import { Link } from "react-router-dom";
import {
  fastCashAdded,
  fastCashAmount,
  getFastCashes,
} from "../fast cash/fastCashSlice";
import { getVendors } from "../vendors/vendorSlice";
import { v4 as uuidv4 } from "uuid";
import DialogComponent from "../reusableComponents/Dialog";
import moment from "moment";
import defaultImg from "../../images/defaultimg.png";
import AddUnit from "../units/AddUnit";
import UnitsList from "../units/UnitsList";
import AddVendor from "../vendors/AddVendor";
import { toast } from "react-toastify";
import { createFastCash, createFastCashEntry } from "../fast cash/httpCalls";
import S3FileUpload from "react-s3/lib/ReactS3";
import { getUnits } from "../units/unitSlice";
import { addItem, editItem } from "./itemsSlice";
import { addItem as addToSelect } from "../point of sale/saleSlice";
import { saveItem } from "./httpCalls";
import DateField from "../components/DateField";
import { BoxesPacking } from "../features/BoxesPacking";
import { getLedgersNames } from "../ledgers/ledgersNamesSlice";
import AddBatchNo from "./AddBatchNo";
import ShowBatchNos from "./ShowBatchNos";
import Config from "../../utils/Config";
import useGetRacks from "../racks/useGetRacks";
import { itemNewDesign } from "../features/ItemNewDesign";

const Input = styled("div")({
  border: "1px solid #4daf51",
  height: "60px",
  padding: "7px",
  borderRadius: "10px",
  boxShadow: "0px 3px 7px #4daf51",
});

function AddItem({ onClose, items, myShops, sale = "" }) {
  let digits = localStorage.getItem("barcodeDigits");
  const companyCode = localStorage.getItem("companyCode");
  const dispatch = useDispatch();
  const fastCashes = useSelector((state) => state.fastCash.fastCashes);
  const { ledgersNames } = useSelector((state) => state.ledgersNames);
  const inventory = useSelector((state) => state.inventory.items);
  console.log("inventory", inventory);
  const vendor = useSelector((state) => state.vendor);
  const units = useSelector((state) => state.units);
  const { status } = useSelector((state) => state.trial);
  console.log("sssstus", status);
  const [barcodeDigits, setBarcodeDigits] = useState(digits || 4);
  const [itemImg, setItemImg] = useState(null);
  const [state, setState] = useState({
    loading: false,
    error: "",
    imgFile: [],
    existsItems: [],
    expiryDate: "",
    fastCash: false,
    box: false,
    selectedFastCash: "",
    createFastCash: false,
    cashName: "",
    perBox: "",
    cashComment: "",
    pricePerPiece: 0,
    piecesPerBox: 0,
    cashAmount: "",
    quantity: "",
    cashDate: "",
    cameraOpen: false,
    imgFileBase: "",
    dateOfPurchase: "",
    warningOpen: false,
    sameCode: true,
    openList: false,
    batchModal: false,
    showUnits: false,
    unitsModal: false,
    vendorModal: false,
    allBatchModal: false,
    batchModal: false,
    iMeiField: false,
    itemExist: false,
    steelWeightField: false,
    useWeight: false,
    newItem: {
      name: "",
      shop_code: "",
      discount: 0,
      weight: 0,
      rack_code: "",
      sub_rack_code: "",
      itemId: "",
      description: "",
      category: "Lights",
      companyPrice: "",
      quantity: "0",
      minquantity: "",
      itemCode: "",
      price: "",
      costPrice: "",
      vendor: "",
      weightType: false,
      unit: "",
      barCode: "",
      batchNumber: [],
      expiryDate: "",
      whole_sale_price: "",
      boxes: 0,
      packing: 0,
      imgURL: "",
      imeiNumber: "",
      saleLabel: "",
      totalBoxes: "",
      // steelWeightField: 0,
    },
  });
  console.log("stateNew", state.newItem.saleLabel);
  console.log("newItem", state.newItem.batchNumber);
  console.log("stateNew", state.newItem.expiryDate);
  const { racks } = useGetRacks();

  let totalQuantity;

  useEffect(() => {
    if (fastCashes == "") {
      dispatch(getFastCashes());
    }
    if (ledgersNames.length == 0) {
      dispatch(getLedgersNames());
    }
    if (vendor.vendors == "") {
      dispatch(getVendors());
    }
    if (units.units == "") {
      dispatch(getUnits());
    }
    totalQuantity;
  }, []);

  totalQuantity = useMemo(() => {
    const total = state?.newItem?.totalBoxes * state?.piecesPerBox;
    console.log("totallll", total);
    if (total) {
      setState((pre) => ({
        ...pre,
        newItem: { ...pre.newItem, quantity: total },
      }));
    }
  }, [state?.newItem?.totalBoxes, state?.piecesPerBox]);

  const handleBox = (e) => {
    let name = e.target.name;
    let value;
    if (name == "box" || name == "createFastCash") {
      value = e.target.checked;
    } else {
      value = e.target.value;
    }
    setState((pre) => ({ ...pre, [name]: value }));
  };

  const pricePerBoxHandler = () => {
    const pricePerBox =
      Number(state.newItem.price) / Number(state.piecesPerBox);
    console.log("priceperbox", pricePerBox);
    return pricePerBox;
  };
  const handleWeight = (e) => {
    const { name } = e.target;
    let value = e.target.checked;
    if (name == "useImei") {
      setState((pre) => ({
        ...pre,
        iMeiField: !state.iMeiField,
        // useWeight: !pre.useWeight,
      }));
    } else if (name == "steelWeightField") {
      console.log("name else if", name);
      setState((pre) => ({
        ...pre,
        steelWeightField: !state.steelWeightField,
      }));
    } else {
      console.log("name else", name);

      setState((pre) => ({
        ...pre,
        newItem: { ...pre.newItem, weightType: value, quantity: 0, weight: 0 },
        useWeight: !pre.useWeight,
      }));
    }
  };
  const handleWarehouse = (e) => {
    const { value } = e.target;

    setState((pre) => ({
      ...pre,
      newItem: {
        ...pre.newItem,
        shop_code: {
          shopName: myShops[value].shopName,
          shop_code: myShops[value].shop_code,
        },
      },
    }));
  };
  // const handleInput = (e) => {
  //   let { name, value } = e.target;
  //   // let findName;

  //   if (name == "boxes") {
  //     if (state.newItem.packing) {
  //       let qty = value * state.newItem.packing;
  //       setState((pre) => ({
  //         ...pre,
  //         newItem: { ...pre.newItem, [name]: value, quantity: qty },
  //       }));
  //     } else {
  //       setState((pre) => ({
  //         ...pre,
  //         newItem: { ...pre.newItem, [name]: value },
  //       }));
  //     }
  //   } else if (name == "packing") {
  //     if (state.newItem.boxes) {
  //       let qty = value * state.newItem.boxes;
  //       setState((pre) => ({
  //         ...pre,
  //         newItem: { ...pre.newItem, quantity: qty, [name]: value },
  //       }));
  //     } else {
  //       setState((pre) => ({
  //         ...pre,
  //         newItem: { ...pre.newItem, [name]: value },
  //       }));
  //     }
  //   } else {
  //     setState((pre) => ({
  //       ...pre,
  //       newItem: { ...pre.newItem, [name]: value },
  //     }));
  //   }

  //   if (name === "name") {
  //     const findName = inventory.find((item) => {
  //       console.log('item.name', item.name)
  //     console.log('state.newItem.name', state.newItem.name)
  //      return item.name.trim().toLowerCase() === state.newItem.name.trim().toLowerCase()
  //   });

  //     console.log("findName", findName);

  //     // Compute `itemExist` immediately
  //     const itemExist = !!findName;

  //     // Update the state with the computed value
  //     setState((pre) => ({
  //       ...pre,
  //       itemExist, // Update directly with the computed value
  //     }));

  //     // Use `itemExist` immediately if needed
  //     console.log("itemExist:", itemExist);
  //   }

  // };

  const handleInput = (e) => {
    const { name, value } = e.target;
    console.log("nameee", name);
    console.log("valueee", value);
    // Update the newItem state first
    setState((pre) => ({
      ...pre,
      newItem: { ...pre.newItem, [name]: value },
    }));
    // Perform name-specific logic after updating state
    if (name === "name") {
      const findName = inventory.find((item) => {
        console.log("item.name", item.name);
        console.log("value (new name)", value); // Use the current value from the input
        return item.name.trim().toLowerCase() === value.trim().toLowerCase();
      });

      console.log("findName", findName);

      // Compute `itemExist` based on `findName`
      const itemExist = !!findName;

      // Update the state with the computed value
      setState((pre) => ({
        ...pre,
        itemExist, // Update directly with the computed value
      }));

      console.log("itemExist:", itemExist);
    } else if (name === "boxes") {
      if (state.newItem.packing) {
        const qty = value * state.newItem.packing;
        setState((pre) => ({
          ...pre,
          newItem: { ...pre.newItem, [name]: value, quantity: qty },
        }));
      } else {
        setState((pre) => ({
          ...pre,
          newItem: { ...pre.newItem, [name]: value },
        }));
      }
    } else if (name === "packing") {
      if (state.newItem.boxes) {
        const qty = value * state.newItem.boxes;
        setState((pre) => ({
          ...pre,
          newItem: { ...pre.newItem, quantity: qty, [name]: value },
        }));
      } else {
        setState((pre) => ({
          ...pre,
          newItem: { ...pre.newItem, [name]: value },
        }));
      }
    } else if (name === "expiryDate") {
      setState((pre) => ({
        ...pre,
        newItem: { ...pre.newItem, expiryDate: value },
      }));
    }
  };

  const toggle = (name) => {
    setState((pre) => ({ ...pre, [name]: !pre[name] }));
  };
  const handleBarcode = (e) => {
    const { value } = e.target;
    setBarcodeDigits(value);
    localStorage.setItem("barcodeDigits", value);
  };

  const handleTakePhoto = (dataUri) => {
    setState((pre) => ({ ...pre, cameraOpen: true, imgFileBase: dataUri }));
  };

  const handleImage = (e) => {
    // setState((pre) => ({ ...pre, imgFile: e.target.files[0] }));\
    if (e.target?.files?.length > 0) {
      setItemImg(e.target.files[0]);
    } else {
      setItemImg(null);
    }
  };
  const handleItemId = (e) => {
    let value = e.target.value;
    if (state.sameCode == true) {
      let filtered = items?.filter((item) => {
        if (value) {
          return item.itemId == value || item.itemCode == value;
        }
      });
      if (filtered.length > 0) {
        setState((pre) => ({
          ...pre,
          warningOpen: true,
          existsItems: filtered,
        }));
      }
    }
    handleInput(e);
  };

  const handleList = () => {
    setState((pre) => ({
      ...pre,
      warningOpen: false,
      sameCode: false,
      openList: true,
    }));
  };

  const handleOpenList = () => {
    setState((pre) => ({ ...pre, openList: false, sameCode: false }));
  };

  const handleSubmit = async () => {
    let date = moment(Date.now()).format("DD-MM-YYYY");
    if (state.box == true) {
      // if (state.perBox == "" ) {
      //   toast.configure();
      //   toast.info("Enter Fast Cash name or Select");
      //   return;
      // }
      // if (state.pricePerPiece == "") {
      //   toast.configure();
      //   toast.info("Enter Fash Cash Amount!");
      //   return;
      // }
    }

    // const batchCostPrice = state.newItem.batchNumber.map((item, index) => {
    //   console.log("item", item);
    //   return item?.newItem?.costPrice;
    // });

    // const batchSalePrice = state.newItem.batchNumber.map((item, index) => {
    //   console.log("item", item);

    //   return item?.newItem?.price;
    // });

    // const pricePerPiece = state.newItem.batchNumber.map((item, index) => {
    //   console.log("item", item);

    //   return item?.pricePerPiece;
    // });

    // const itemBox = state.newItem.batchNumber.map((item, index) => {
    //   console.log("item", item);

    //   return item?.box;
    // });

    toast.configure(); // Configure once at the start if required

    // Extract batch details
    const batchDetails = state.newItem.batchNumber.map((item) => ({
      costPrice: item?.newItem?.costPrice,
      salePrice: item?.newItem?.price,
      pricePerPiece: item?.pricePerPiece,
      piecesPerBox: item?.piecesPerBox,
      box: item?.box,
    }));
    console.log(" state.newItem", state.newItem);

    console.log(" batchDetails", batchDetails);

    // Extract specific arrays
    const batchCostPrice = batchDetails.find((item) => item.costPrice);
    const batchSalePrice = batchDetails.find((item) => item.salePrice);
    const pricePerPiece = batchDetails.find((item) => item.pricePerPiece);
    const piecesPerBox = batchDetails.find((item) => item.piecesPerBox);
    const itemBoxBatch = batchDetails.find((item) => item.box == true);

    console.log("batchCostPrice", batchCostPrice);
    console.log("batchSalePrice ", batchSalePrice);

    console.log(" pricePerPiece", pricePerPiece);
    console.log("itemBoxBatch", itemBoxBatch);
    if (state.newItem.costPrice === "" && batchCostPrice === undefined) {
      toast.configure();
      toast.info("Please enter the Cost Price / Batch Cost Price");
      return;
    }

    console.log("batchSalePrice", batchSalePrice);

    if (state.newItem.price == "" && batchSalePrice == undefined) {
      toast.configure();
      toast.info("Please enter the Sale Price // Batch Sale Price");
      return;
    }

    if (itemBoxBatch) {
      if (
        (pricePerPiece.pricePerPiece === undefined ||
          pricePerPiece.pricePerPiece === Infinity) &&
        (pricePerPiece.piecesPerBox === undefined ||
          pricePerPiece.piecesPerBox === "" ||
          Number(pricePerPiece.piecesPerBox) === 0)
      ) {
        toast.configure();
        toast.info("Price Per Piece Is Empty Or Pieces Per Box");
        return;
      }
      console.log("pricePerPiece", pricePerPiece);
      console.log("piecesPerBox", Number(state.piecesPerBox));
      console.log("pricePerBox", Number(state.piecesPerBox));
    }

    if (state.newItem.name == "") {
      toast.configure();
      toast.info("Please enter the name!");
      return;
    }
    // if (state.newItem.quantity == "0" && state.newItem.weight == 0) {
    //   toast.configure();
    //   toast.info("Please enter either quantity or weight!");
    //   return;
    // }
    if (state.newItem.description == "") {
      toast.configure();
      toast.info("Please enter the description!");
      return;
    }

    console.log("pecesperbox", Number(state.piecesPerBox));
    console.log("pecesperbox", pricePerBoxHandler());

    if (state.box) {
      if (Number(state.piecesPerBox == 0)) {
        toast.configure();
        toast.info("Please enter  Pieces Per Box ");
        return;
      }
    }
    // if (state.newItem.minquantity == "") {
    //   toast.configure();
    //   toast.info("Please enter the minimum quantity!");
    //   return;
    // }
    console.log("statee", state.newItem);

    onClose();
    setState((pre) => ({ ...pre, loading: true }));

    let itemCode = state.newItem.itemId
      ? state.newItem.itemId
      : Math.floor(Math.random() * 9000 + 1000);
    let id = uuidv4();
    let _id = id.replaceAll("-", "");
    let newId = uuidv4();
    let itemId = newId.replaceAll("-", "");
    // const expiryDateUnix = new Date(state.newItem.expiryDate).getTime() / 1000;
    const expiryDateUnix = state.newItem.expiryDate;
    console.log("exi", expiryDateUnix);
    let item = state.newItem;
    item.steelWeightKg = Number(state?.newItem?.steelWeight);
    item.steelWeightTotal = Number(
      state?.newItem?.steelWeight * state?.newItem?.quantity
    );
    console.log("state", state.newItem);
    item._id = itemId;
    item.expiryDate = expiryDateUnix;
    if (itemImg) {
      S3FileUpload.uploadFile(itemImg, Config()).then(async (data) => {
        dispatch(
          addItem({
            index: 0,
            item: {
              ...item,
              itemId: itemCode,
              imgURL: data.location,
              company_code: companyCode,
            },
          })
        );
        if (state.box) {
          if (state.createFastCash == true) {
            const user = {
              _id: _id,
              date: date,
              name: state.perBox,
              totalAmount: state.pricePerPiece,
              companyCode: companyCode,
            };
            // dispatch(fastCashAdded(user));
            Promise.all([
              // createFastCash(companyCode, state.perBox, date, _id, dispatch),

              saveItem(
                {
                  ...item,
                  itemId: itemCode,
                  imgURL: data.location,
                  company_code: companyCode,
                  imeiNumber: state.newItem.imeiNumber,
                  // pricePerBox:state.perBox,
                },
                dispatch,
                Number(state.piecesPerBox),
                state.box,
                pricePerBoxHandler(),
                status
              ),
            ])
              .then((res) => {
                // createFastCashEntry(
                //   companyCode,
                //   state.perBox,
                //   state.piecesperBox,
                //   state.piecesperBox,
                //   date,
                //   _id,
                //   dispatch
                // );
              })
              .catch((err) => {
                toast.configure();
                toast.error("Error");
              });
          } else {
            // dispatch(
            //   fastCashAmount({
            //     _id: state.selectedFastCash,
            //     amount: state.pricePerPiece,
            //   })
            // );
            console.log("itemmmmmmmm", item);
            Promise.all([
              // createFastCashEntry(
              //   companyCode,
              //   state.perBox,
              //   state.piecesperBox,
              //   state.pricePerPiece,
              //   date,
              //   state.selectedFastCash,
              //   dispatch
              // ),
              saveItem(
                {
                  status,

                  ...item,
                  itemId: itemCode,
                  imgURL: data.location,
                  company_code: companyCode,
                },
                dispatch,
                Number(state.piecesPerBox),
                state.box,
                pricePerBoxHandler(),
                status
              ),
            ]);
          }
        } else {
          console.log("itemmmmmmmm", item);

          saveItem(
            {
              status,
              ...item,
              itemId: itemCode,
              imgURL: data.location,
              company_code: companyCode,
            },
            dispatch,
            Number(state.piecesPerBox),
            state.box,
            pricePerBoxHandler(),
            status
          );
        }
      });
    } else {
      dispatch(
        addItem({
          index: 0,
          item: {
            ...item,
            itemId: itemCode,
            imgName: "",
            company_code: companyCode,
          },
        })
      );
      if (sale == "true") {
        dispatch(
          addToSelect({
            ...item,
            itemId: itemCode,
            imgName: "",
            company_code: companyCode,
          })
        );
      }
      if (state.box) {
        if (state.createFastCash == true) {
          const user = {
            _id: _id,
            date: date,
            name: state.perBox,
            totalAmount: state.pricePerPiece,
            companyCode: companyCode,
          };
          console.log("itemmmmmmmm", item);

          // dispatch(fastCashAdded({ index: 0, user: user }));
          Promise.all([
            // createFastCash(companyCode, state.perBox, date, _id, dispatch),

            saveItem(
              {
                status,
                ...item,
                itemId: itemCode,
                imgName: "",
                company_code: companyCode,
              },
              dispatch,
              Number(state.piecesPerBox),
              state.box,
              pricePerBoxHandler(),
              status
            ),
          ])
            .then((res) => {
              // createFastCashEntry(
              //   companyCode,
              //   state.perBox,
              //   state.piecesperBox,
              //   state.pricePerPiece,
              //   date,
              //   _id,
              //   dispatch
              // );
            })
            .catch((err) => {
              toast.configure();
              toast.error("Error");
            });
        } else {
          // dispatch(
          //   fastCashAmount({
          //     _id: state.selectedFastCash,
          //     amount: state.pricePerPiece,
          //   })
          // );
          console.log("itemmmmmmmm", item);

          Promise.all([
            // createFastCashEntry(
            //   companyCode,
            //   state.perBox,
            //   state.piecesperBox,
            //   state.pricePerPiece,
            //   date,
            //   state.selectedFastCash,
            //   dispatch
            // ),
            saveItem(
              {
                status,
                ...item,
                itemId: itemCode,
                imgName: "",
                company_code: companyCode,
              },
              dispatch,
              Number(state.piecesPerBox),
              state.box,
              pricePerBoxHandler(),
              status
            ),
          ]);
        }
      } else {
        console.log("itemmmmmmmm", item);

        saveItem(
          {
            status,
            ...item,
            itemId: itemCode,
            imgName: "",
            company_code: companyCode,
          },
          dispatch,
          Number(state.piecesPerBox),
          state.box,
          pricePerBoxHandler(),
          status
        );
      }
    }
  };

  const handleBatch = (e) => {
    let value = e;
    console.log("value", value);
    // const pricePerBox = state.newItem.price / state.piecesperBox;
    // const pricePerPiece = Number(value.newItem.price) / Number(value.piecesperBox)
    // console.log("pricePerPiece", pricePerPiece);
    console.log("eee", e);
    console.log("value", value);

    setState((prev) => ({
      ...prev,
      batchModal: false,
      newItem: {
        ...prev.newItem,
        batchNumber: [...prev.newItem.batchNumber, value],
        quantity: Number(prev.newItem.quantity) + Number(e.quantity),
        expiryDate: value.expiryDate,
      },
    }));
  };

  const handleUpdateBatch = (e) => {
    console.log("ee", e);
    let oldQty = state.newItem.batchNumber.reduce((acc, item) => {
      acc += parseInt(item.quantity);
      return acc;
    }, 0);
    let newQty = e.reduce((acc, item) => {
      acc += parseInt(item.quantity);
      return acc;
    }, 0);
    let final = oldQty - newQty;
    setState((prev) => ({
      ...prev,
      allBatchModal: false,
      newItem: {
        ...prev.newItem,
        quantity: prev.newItem.quantity - final,
        batchNumber: e,
      },
    }));
  };

  const handleGenerateBarcode = () => {
    let randomBarcode;
    if (barcodeDigits == 4) {
      randomBarcode = Math.floor(Math.random() * 9000) + 1000;
    } else {
      randomBarcode =
        Math.floor(Math.random() * 90000000000000) + 10000000000000;
    }
    setState((pre) => ({
      ...pre,
      newItem: { ...pre.newItem, barCode: randomBarcode.toString() },
    }));
  };
  const priceBoxHandler = () => {
    const priceperpiece = state.perbox / state.piecesPerBox;
    setState((pre) => ({
      ...pre,
      pricePerPiece: priceperpiece,
    }));
    return priceperpiece;
  };
  return (
    <Box>
      <Typography
        sx={{
          textAlign: "center",
          color: "#4EAF51",
          fontSize: { md: "2.125rem", xs: "14px" },
        }}
      >
        Add Your Item Now!
      </Typography>
      <Typography variant="body1">{state.error}</Typography>

      {state.box == true && (
        <Container>
          {/* <Stack alignItems="flex-end">
            <FormControlLabel
              control={
                <Checkbox
                  checked={state.createFastCash}
                  name="createFastCash"
                  onChange={handleBox}
                />
              }
              label="Create New"
            />
          </Stack> */}

          {/* {state.createFastCash == false && (
             <TextField
             value={state.perBox}
             size="small"
             required
             autoFocus
             name="perBox"
             label="Price Per Box"
             type="number"
             fullWidth
             variant="outlined"
             style={{ background: "#F2F2F2" }}
             onChange={handleBox}
           />
          )} */}

          {state.createFastCash == true && (
            <TextField
              value={state.cashName}
              size="small"
              required
              autoFocus
              name="cashName"
              label="Name"
              type="text"
              fullWidth
              variant="outlined"
              style={{ background: "#F2F2F2" }}
              onChange={handleBox}
            />
          )}
          {/* 
          <TextField
            size="small"
            value={state.piecesperBox}
            required
            variant="outlined"
            name="piecesperBox"
            label="Pieces Per Box"
            type="number"
            fullWidth
            style={{ background: "#F2F2F2", marginTop: "10px" }}
            onChange={handleBox}
          /> */}
          {/* 
          <TextField
            size="small"
            value={pricePerBoxHandler()}
            required
            variant="outlined"
            name="pricePerPiece"
            label="Price Per Piece"
            type="number"
            fullWidth
            style={{
              background: "#F2F2F2",
              marginTop: "10px",
              marginBottom: "10px",
            }}
            onChange={handleBox}
          /> */}

          {/* <TextField
            size="small"
            value={state.quantity}
            required
            variant="outlined"
            name="quantity"
            label="Quantity"
            type="number"
            fullWidth
            style={{
              background: "#F2F2F2",
              marginTop: "10px",
              marginBottom: "10px",
            }}
            onChange={handleBox}
          /> */}
        </Container>
      )}
      <Stack spacing={2}>
        {!itemNewDesign() && (
          <TextField
            fullWidth
            size="small"
            type="file"
            multiple
            variant="outlined"
            sx={{ mt: 2 }}
            onChange={handleImage}
          />
        )}
        <Input>
          <TextField
            variant="standard"
            value={state.newItem.name}
            required
            autoFocus
            name="name"
            label="Name"
            type="text"
            fullWidth
            InputProps={{ disableUnderline: true }}
            onChange={handleInput}
          />
        </Input>
        {/* {state.itemExist && (
          <Typography
            variant="body2"
            color="error"
            sx={{ marginTop: "0.25rem" }}
          >
            This item is already added!
          </Typography>
        )} */}
        <Input>
          <TextField
            variant="standard"
            name="description"
            label="Description"
            type="text"
            fullWidth
            InputProps={{ disableUnderline: true }}
            value={state.newItem.description}
            onChange={handleInput}
          />
        </Input>
        {itemNewDesign() && (
          <>
            <Input>
              <TextField
                variant="standard"
                name="material"
                label="Material"
                type="text"
                fullWidth
                InputProps={{ disableUnderline: true }}
                value={state.newItem.material || ""}
                onChange={handleInput}
              />
            </Input>
            <Input>
              <TextField
                variant="standard"
                name="carModel"
                label="Car/Model"
                type="text"
                fullWidth
                InputProps={{ disableUnderline: true }}
                value={state.newItem.carModel || ""}
                onChange={handleInput}
              />
            </Input>
            <Input>
              <TextField
                variant="standard"
                name="color"
                label="Colour"
                type="text"
                fullWidth
                InputProps={{ disableUnderline: true }}
                value={state.newItem.color || ""}
                onChange={handleInput}
              />
            </Input>
          </>
        )}
        {!itemNewDesign() && (
          <Input>
            {units.loading && (
              <ClipLoader size={30} color={"#4DAF51"} loading={units.loading} />
            )}
            <FormControl style={{ width: "100%" }}>
              {companyCode == "8553" ? (
                <InputLabel>Select Size</InputLabel>
              ) : (
                <InputLabel>Select Unit</InputLabel>
              )}
              <Select
                variant="standard"
                label="Select Unit"
                name="unit"
                onChange={handleInput}
                value={state.newItem.unit}
              >
                {units?.units.map((unit, i) => {
                  return (
                    <MenuItem key={i} value={unit}>
                      {unit}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Input>
        )}
        {!itemNewDesign() && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              margin: "20px 20px",
            }}
          >
            <Button
              size="small"
              variant="contained"
              onClick={() => toggle("showUnits")}
              style={{ color: "#ffff" }}
            >
              {companyCode == "8553" ? "Size" : "Unit"}
            </Button>
            <Button
              size="small"
              onClick={() => toggle("unitsModal")}
              style={{ color: "#4EAF51" }}
            >
              {companyCode == "8553" ? "Add Size" : "Add Unit"}
            </Button>
          </div>
        )}

        {!itemNewDesign() && (
          <Input>
            <FormControl style={{ width: "100%" }}>
              <InputLabel>Warehouse</InputLabel>

              <Select
                variant="standard"
                name="shop_code"
                onChange={handleWarehouse}
                // value={state.newItem.shop_code?.shopName}
                defaultValue=""
              >
                {myShops &&
                  myShops.map((item, i) => {
                    return (
                      <MenuItem key={i} value={i}>
                        {item.shopName}
                      </MenuItem>
                    );
                  })}
              </Select>
            </FormControl>
          </Input>
        )}

        {!itemNewDesign() && (
          <Input>
            <FormControl style={{ width: "100%" }}>
              <InputLabel>Racks</InputLabel>
              <Select
                variant="standard"
                name="rack_code"
                onChange={handleInput}
                value={state.newItem.rack_code}
              >
                {racks.map((item, i) => {
                  return (
                    <MenuItem key={i} value={item._id}>
                      {item.racks.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Input>
        )}

        {!itemNewDesign() && state.newItem.rack_code != "" && (
          <Input>
            <FormControl style={{ width: "100%" }}>
              <InputLabel>Sub Racks</InputLabel>
              <Select
                variant="standard"
                name="sub_rack_code"
                onChange={handleInput}
                value={state.newItem.sub_rack_code}
              >
                {racks
                  .find((its) => its._id == state.newItem.rack_code)
                  .racks.sub_rack.map((itsub, i) => {
                    return (
                      <MenuItem key={i} value={itsub}>
                        {itsub}
                      </MenuItem>
                    );
                  })}
              </Select>
            </FormControl>
          </Input>
        )}
        {!itemNewDesign() && ledgersNames.length > 0 && (
          <Input>
            <FormControl style={{ width: "100%" }}>
              <InputLabel>Ledgers</InputLabel>
              <Select
                variant="standard"
                name="ledger"
                defaultValue=""
                onChange={handleInput}
                //   value={state.newItem.ledger}
              >
                {ledgersNames.map((item, i) => {
                  return (
                    <MenuItem key={i} value={item._id}>
                      {item.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Input>
        )}
        {state.newItem.batchNumber == 0 && (
          <>
            {!itemNewDesign() && (
              <Stack alignItems="flex-end">
                {!itemNewDesign() && (
                  <Stack alignItems="flex-end">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={state.box}
                          name="box"
                          onChange={handleBox}
                        />
                      }
                      label="Ctn"
                    />
                  </Stack>
                )}
                <Stack direction="row" alignItems="center">
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="steelWeightField"
                        checked={state.newItem.steelWeight}
                        onChange={handleWeight}
                      />
                    }
                    label="Steel Weight"
                  />

                  <Link
                    to="/inventory/admin/ledgers"
                    style={{ color: "#4EAF51" }}
                  >
                    Create Ledgers
                  </Link>
                </Stack>
              </Stack>
            )}

            {!itemNewDesign() && state.box == true && (
              <Stack
                direction="row"
                justifyContent="space-between"
                sx={{ gap: { md: "0px", xs: "5px" } }}
              >
                {
                  <Input>
                    <TextField
                      variant="standard"
                      name="totalBoxes"
                      label={state.newItem.saleLabel === "box" ? "Box" : "Ctn"}
                      value={state.newItem.totalBoxes}
                      type="Number"
                      fullWidth
                      InputProps={{ disableUnderline: true }}
                      onChange={handleInput}
                    />
                  </Input>
                }

                <Input>
                  <TextField
                    variant="standard"
                    name="piecesPerBox"
                    label={
                      state.newItem.saleLabel === "box"
                        ? "Pieces Per Box"
                        : "Box Per Ctn"
                    }
                    value={state.piecesPerBox}
                    type="Number"
                    fullWidth
                    InputProps={{ disableUnderline: true }}
                    onChange={handleBox}
                  />
                </Input>
              </Stack>
            )}

            {!itemNewDesign() && state.useWeight == true && (
              <Input>
                <TextField
                  variant="standard"
                  name="weight"
                  label="Weight in (kg)"
                  type="Number"
                  fullWidth
                  InputProps={{ disableUnderline: true }}
                  value={state.newItem.weight}
                  onChange={handleInput}
                />
              </Input>
            )}
            {!itemNewDesign() && state.useWeight != true && (
              <Stack>
                {BoxesPacking() && (
                  <Stack direction="row" spacing={2} marginBottom="20px">
                    <TextField
                      size="small"
                      variant="outlined"
                      value={state.newItem.boxes}
                      name="boxes"
                      label="Boxes"
                      fullWidth
                      type="number"
                      onChange={handleInput}
                    />

                    <TextField
                      size="small"
                      variant="outlined"
                      value={state.newItem.packing}
                      name="packing"
                      label="Packing"
                      fullWidth
                      type="number"
                      onChange={handleInput}
                    />
                  </Stack>
                )}
                <Stack spacing={2}>
                  <Input>
                    <TextField
                      variant="standard"
                      value={state.newItem.quantity}
                      name="quantity"
                      label="Quantity"
                      type="Number"
                      fullWidth
                      InputProps={{ disableUnderline: true }}
                      onChange={handleInput}
                    />
                  </Input>
                  {state.steelWeightField && (
                    <Input>
                      <TextField
                        variant="standard"
                        value={state.newItem.steelWeight}
                        name="steelWeight"
                        // label="Steel Weight/Kg"
                        label="Kg Per Quantity"
                        type="Number"
                        fullWidth
                        InputProps={{ disableUnderline: true }}
                        onChange={handleInput}
                      />
                    </Input>
                  )}
                  {state.steelWeightField && (
                    <Input>
                      <TextField
                        variant="standard"
                        value={
                          state?.newItem?.steelWeight * state?.newItem?.quantity
                        }
                        // name="steelWeightPerKg"
                        label="Steel Weight/Kg"
                        type="Number"
                        fullWidth
                        InputProps={{ disableUnderline: true }}
                        // onChange={handleInput}
                      />
                    </Input>
                  )}
                </Stack>

                {state.newItem.unit == "Role" && (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    marginTop="10px"
                  >
                    <Input>
                      <TextField
                        label="Meter"
                        variant="standard"
                        value={parseInt(state.newItem.quantity * 100) || 0}
                        type="Number"
                        fullWidth
                        InputProps={{ disableUnderline: true }}
                      />
                    </Input>
                    <Input>
                      <TextField
                        label="RFT"
                        variant="standard"
                        value={parseInt(state.newItem.quantity * 328) || 0}
                        type="Number"
                        fullWidth
                        InputProps={{ disableUnderline: true }}
                      />
                    </Input>
                  </Stack>
                )}
              </Stack>
            )}
            {itemNewDesign() && (
              <Input>
                <TextField
                  variant="standard"
                  value={state.newItem.quantity}
                  name="quantity"
                  label="Stock"
                  type="number"
                  fullWidth
                  InputProps={{ disableUnderline: true }}
                  onChange={handleInput}
                />
              </Input>
            )}
            {!itemNewDesign() && (
              <Stack alignItems="flex-end">
                <Stack direction="row">
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="useWeight"
                        checked={state.newItem.checked}
                        onChange={handleWeight}
                      />
                    }
                    label="Select Weight"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="useImei"
                        checked={state.newItem.checked}
                        onChange={handleWeight}
                      />
                    }
                    label="Add IMEI Number"
                  />
                </Stack>
              </Stack>
            )}

            {!itemNewDesign() && (
              <Input>
                <TextField
                  variant="standard"
                  value={state.newItem.discount}
                  name="discount"
                  label="Discount"
                  type="Number"
                  fullWidth
                  InputProps={{ disableUnderline: true }}
                  onChange={handleInput}
                />
              </Input>
            )}
            {state.iMeiField && (
              <Input>
                <TextField
                  variant="standard"
                  name="imeiNumber"
                  label="Imei number"
                  type="text"
                  fullWidth
                  InputProps={{ disableUnderline: true }}
                  value={state.newItem.imeiNumber}
                  onChange={handleInput}
                />
              </Input>
            )}

            <Input>
              <TextField
                variant="standard"
                name="minquantity"
                label="Min Quantity"
                type="Number"
                fullWidth
                InputProps={{ disableUnderline: true }}
                value={state.newItem.minquantity}
                onChange={handleInput}
              />
            </Input>
            {!itemNewDesign() && (
              <Input>
                <TextField
                  variant="standard"
                  name="itemId"
                  label="Item Code"
                  type="text"
                  fullWidth
                  value={state.newItem.itemId}
                  InputProps={{ disableUnderline: true }}
                  onChange={handleItemId}
                />
              </Input>
            )}

            <Input>
              <TextField
                variant="standard"
                label="Bar Code"
                type="number"
                name="barCode"
                value={state.newItem.barCode}
                fullWidth
                InputProps={{ disableUnderline: true }}
                onChange={handleInput}
              />
            </Input>
            <Stack
              direction="row"
              alignItems="start"
              justifyContent="space-between"
            >
              <FormControl>
                <FormLabel>Digits</FormLabel>
                <RadioGroup row value={barcodeDigits} onChange={handleBarcode}>
                  <FormControlLabel
                    value={4}
                    control={<Radio disableRipple />}
                    label="4"
                  />
                  <FormControlLabel
                    value={14}
                    control={<Radio disableRipple />}
                    label="14"
                  />
                </RadioGroup>
              </FormControl>
              <Button
                variant="contained"
                size="small"
                sx={{ textTransform: "none" }}
                onClick={handleGenerateBarcode}
              >
                {state.newItem.barCode
                  ? "Generate new Barcode"
                  : "Generate Barcode"}
              </Button>
            </Stack>
            {!itemNewDesign() && (
              <Stack
                direction="row"
                width="100%"
                justifyContent="space-between"
              >
                <Box>
                  <Button
                    size="small"
                    variant="contained"
                    sx={{ textTransform: "none" }}
                    onClick={() => toggle("allBatchModal")}
                  >
                    Batch Numbers
                  </Button>
                </Box>
                <Box>
                  <Button
                    size="small"
                    variant="contained"
                    sx={{ textTransform: "none" }}
                    onClick={() => toggle("batchModal")}
                  >
                    Add Batch No.
                  </Button>
                </Box>
              </Stack>
            )}

            {!itemNewDesign() && (
              <Stack
                direction="row"
                justifyContent="space-between"
                sx={{ gap: { md: "0px", xs: "5px" } }}
              >
                {
                  <Input>
                    <TextField
                      variant="standard"
                      name="costPrice"
                      label={
                        state.box
                          ? state.newItem.saleLabel === "box"
                            ? "Cost Price Per Box"
                            : "Cost Price Per Ctn"
                          : "Cost Price"
                      }
                      value={state.newItem.costPrice}
                      type="Number"
                      fullWidth
                      InputProps={{ disableUnderline: true }}
                      onChange={handleInput}
                    />
                  </Input>
                }

                <Input>
                  <TextField
                    variant="standard"
                    value={state.newItem.price}
                    name="price"
                    label={
                      state.box
                        ? state.newItem.saleLabel === "box"
                          ? "Sale Price Per Box"
                          : "Sale Price Per Ctn"
                        : "Sale Price"
                    }
                    type="Number"
                    fullWidth
                    InputProps={{ disableUnderline: true }}
                    onChange={handleInput}
                  />
                </Input>
              </Stack>
            )}
            {!itemNewDesign() && (
              <>
                {!state.box && (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    sx={{ gap: { md: "0px", xs: "5px" } }}
                  >
                    <Input>
                      <TextField
                        variant="standard"
                        name="companyPrice"
                        label="Company Price"
                        type="Number"
                        value={state.newItem.companyPrice}
                        fullWidth
                        InputProps={{ disableUnderline: true }}
                        onChange={handleInput}
                      />
                    </Input>

                    <Input>
                      <TextField
                        variant="standard"
                        min="1"
                        label="Whole Sale Price"
                        name="whole_sale_price"
                        value={state.newItem.whole_sale_price}
                        type="number"
                        fullWidth
                        InputProps={{ disableUnderline: true }}
                        onChange={handleInput}
                      />
                    </Input>
                  </Stack>
                )}

                {state.box == true && (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    sx={{ gap: { md: "0px", xs: "5px" } }}
                  >
                    <Input>
                      <TextField
                        variant="standard"
                        name="piecesPerBox"
                        label={
                          state.newItem.saleLabel === "box"
                            ? "Pieces Per Box"
                            : "Box Per Ctn"
                        }
                        value={state.piecesPerBox}
                        type="Number"
                        fullWidth
                        InputProps={{ disableUnderline: true }}
                        onChange={handleBox}
                      />
                    </Input>
                    <Input>
                      <TextField
                        variant="standard"
                        name="pricePerPiece"
                        label={
                          state.newItem.saleLabel === "box"
                            ? "Price Per Piece"
                            : "Price Per Box"
                        }
                        value={pricePerBoxHandler()}
                        type="Number"
                        fullWidth
                        InputProps={{ disableUnderline: true }}
                        onChange={handleInput}
                      />
                    </Input>
                  </Stack>
                )}
              </>
            )}
          </>
        )}
        {itemNewDesign() && (
          <Stack
            direction="row"
            justifyContent="space-between"
            sx={{ gap: { md: "0px", xs: "5px" } }}
          >
            <Input>
              <TextField
                variant="standard"
                value={state.newItem.price}
                name="price"
                label="Sale Price"
                type="Number"
                fullWidth
                InputProps={{ disableUnderline: true }}
                onChange={handleInput}
              />
            </Input>

            <Input>
              <TextField
                variant="standard"
                name="costPrice"
                label="Cost Price"
                type="Number"
                value={state.newItem.costPrice}
                fullWidth
                InputProps={{ disableUnderline: true }}
                onChange={handleInput}
              />
            </Input>
          </Stack>
        )}
        {state.box == true && (
          <Input>
            <FormControl style={{ width: "100%" }}>
              <InputLabel>Select Sale Label</InputLabel>
              <Select
                variant="standard"
                name="saleLabel"
                defaultValue=""
                onChange={handleInput}
                // value={newItem.vendor}
              >
                <MenuItem value="ctn">Ctn</MenuItem>
                <MenuItem value="box">Box</MenuItem>
              </Select>
            </FormControl>
          </Input>
        )}

        {!itemNewDesign() && (
          <Input>
            <FormControl style={{ width: "100%" }}>
              <InputLabel>Items Brands</InputLabel>
              <Select
                variant="standard"
                name="vendor"
                defaultValue=""
                onChange={handleInput}
                // value={newItem.vendor}
              >
                {vendor?.vendors.map((item, i) => {
                  return (
                    <MenuItem key={i} value={item.companyName}>
                      {item.companyName}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Input>
        )}

        <Box>
          <Typography sx={{ textAlign: "left" }}>Expiry Date</Typography>
          <TextField
            fullWidth
            size="small"
            type="date"
            name="expiryDate"
            variant="outlined"
            value={state?.newItem?.expiryDate}
            onChange={handleInput}
          />
        </Box>

        {!itemNewDesign() && (
          <Stack alignItems="flex-end">
            <Button
              size="small"
              onClick={() => toggle("vendorModal")}
              style={{ color: "#4EAF51" }}
            >
              Add Items Brands
            </Button>
          </Stack>
        )}

        {itemNewDesign() && (
          <Input>
            <TextField
              variant="standard"
              name="country"
              label="Country"
              type="text"
              fullWidth
              InputProps={{ disableUnderline: true }}
              value={state.newItem.country || ""}
              onChange={handleInput}
            />
          </Input>
        )}
        {itemNewDesign() && (
          <Input>
            <TextField
              variant="standard"
              name="location"
              label="Location"
              type="text"
              fullWidth
              InputProps={{ disableUnderline: true }}
              value={state.newItem.location || ""}
              onChange={handleInput}
            />
          </Input>
        )}
      </Stack>

      {state.cameraOpen && (
        <div className="camera">
          <Camera
            idealFacingMode={FACING_MODES.ENVIRONMENT}
            isImageMirror={false}
            onTakePhotoAnimationDone={(dataUri) => {
              handleTakePhoto(dataUri);
            }}
          />
        </div>
      )}
      <Stack mt={1} direction="row" justifyContent="space-evenly" spacing={5}>
        <Button fullWidth variant="contained" onClick={handleSubmit}>
          Add
        </Button>
        <Button fullWidth variant="outlined" onClick={onClose}>
          Cancel
        </Button>
      </Stack>

      <DialogComponent
        title={"ItemCode Checking"}
        open={state.warningOpen}
        onClose={() => toggle("warningOpen")}
        dialogContent={
          <>
            <Typography variant="h5" sx={{ color: "red" }}>
              ALERT!
            </Typography>
            <Typography>
              Item with Code already exists click to view list of items or
              continue to add item
            </Typography>
            <Stack direction="row" justifyContent="space-evenly">
              <Button variant="contained" onClick={handleList}>
                View List
              </Button>
              <Button variant="outlined" onClick={() => toggle("warningOpen")}>
                Continue
              </Button>
            </Stack>
          </>
        }
      />
      <DialogComponent
        title="List Open"
        open={state.openList}
        onClose={() => toggle("openList")}
        dialogContent={
          <>
            {state.existsItems.map((item) => {
              return (
                <div key={item._id} className="itembox">
                  <div>
                    <img className="item-img" src={defaultImg} alt="img" />
                  </div>
                  <div className="name-des">
                    <h2>{item.name}</h2>
                    <p className="item-font">
                      Code: {item.itemCode ? item.itemCode : item.itemId}
                    </p>
                    {window.innerWidth <= 799 && (
                      <p className="item-font">Price: {item.price}</p>
                    )}
                    {window.innerWidth >= 800 && (
                      <p className="item-font">{item.description}</p>
                    )}
                    {item.dateOfPurchase != undefined &&
                      window.innerWidth >= 800 &&
                      item.dateOfPurchase != "" && (
                        <p className="item-font">
                          Date of purchase: {getDate(item.dateOfPurchase)}
                        </p>
                      )}
                    {item.modified_at != undefined &&
                      window.innerWidth >= 800 && (
                        <p className="item-font">
                          Updated At:{" "}
                          {moment
                            .unix(item.created_at)
                            .format("DD-MM-YYYY  hh:mm A")}
                        </p>
                      )}
                  </div>
                  <div>
                    {window.innerWidth >= 800 && (
                      <h4 className="regular item-font">
                        Sale Price: {item.price}
                      </h4>
                    )}
                    {item.costPrice != undefined &&
                      window.innerWidth >= 800 && (
                        <h4 className="regular item-font">
                          Cost Price: {item.costPrice}
                        </h4>
                      )}
                    {item.vendor != undefined && window.innerWidth >= 800 && (
                      <h4 className="regular item-font">
                        Vendor: {item.vendor}
                      </h4>
                    )}
                  </div>
                  <div className="quantity-text">
                    <h4>Quantity</h4>
                    <h3>{item.quantity}</h3>
                  </div>
                </div>
              );
            })}
            <Stack direction="row" justifyContent="space-evenly">
              <Button variant="contained" onClick={handleOpenList}>
                Allow Same Code
              </Button>
              <Button variant="outlined" onClick={handleOpenList}>
                Go Back
              </Button>
            </Stack>
          </>
        }
      />
      <DialogComponent
        title={companyCode == "8553" ? "Size" : "Unit"}
        onClose={() => toggle("unitsModal")}
        open={state.unitsModal}
        dialogContent={<AddUnit onClose={() => toggle("unitsModal")} />}
      />
      <DialogComponent
        title="Show Units"
        onClose={() => toggle("showUnits")}
        open={state.showUnits}
        dialogContent={<UnitsList onClose={() => toggle("showUnits")} />}
      />
      <DialogComponent
        title="Add Items Brands"
        onClose={() => toggle("vendorModal")}
        open={state.vendorModal}
        dialogContent={<AddVendor onClose={() => toggle("vendorModal")} />}
      />

      {state.batchModal && (
        <AddBatchNo
          onClose={() => toggle("batchModal")}
          onSuccess={(e) => handleBatch(e)}
        />
      )}
      {state.allBatchModal && (
        <ShowBatchNos
          onClose={() => toggle("allBatchModal")}
          items={state?.newItem?.batchNumber || []}
          onSuccess={(e) => handleUpdateBatch(e)}
        />
      )}
    </Box>
  );
}

export default AddItem;
